module.exports = __webpack_public_path__ + "img/crm.80d2aa5d.png";